import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-analyticshome',
  templateUrl: './analyticshome.component.html',
  styleUrls: ['./analyticshome.component.scss']
})
export class AnalyticshomeComponent {
  constructor(public route: ActivatedRoute){}

  ngOnInit() {
  }

}